import "./photo-slider.css"

import React from "react"

import Slider from "react-slick"

import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/solid"

import { API_BASE_URL } from "../../constants/config"

const NextArrow = ({ onClick }) => {

    return <button
        className="slick-arrow slick-next flex flex-row justify-center items-center"
        onClick={(e) => {
            onClick(e);
            try {
                if (document.querySelector(".videos")[0]) {
                    document.querySelector(".videos").pause();
                }
            }catch(e){
                
            }
        }}>
        <ChevronRightIcon className="w-8 h-8 text-gray-400" />
    </button>
}
const PrevArrow = ({ onClick }) => {

    return <button
        className="slick-arrow slick-prev flex flex-row justify-center items-center"
        onClick={(e) => {
            onClick(e)
            try {
                if (document.querySelector(".videos")[0]) {
                    document.querySelector(".videos").pause();
                }
            }catch(e){
                
            }
        }}>
        <ChevronLeftIcon className="w-8 h-8 text-gray-400" />
    </button>
}

const PhotoSlider = ({ settings, photos }) => {

    return <Slider prevArrow={<PrevArrow />} nextArrow={<NextArrow />} className="photo-slider" {...settings}>
        {photos.map((item, key) => {
            return <div key={key} className="photo">
                {item.media_type === "image" && <img src={API_BASE_URL.replace("/v1", "/") + item.path} alt={"Dog " + (key + 1)} />}
                {item.media_type === "video" && <video className="videos" controls src={API_BASE_URL.replace("/v1", "/") + item.path} alt={"Dog " + (key + 1)} />}
            </div>
        })}
    </Slider>
}

export default PhotoSlider